import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authenticated: false,
    token: '',
    name: 'undefined',
    profileUrl: '',
    url: 'https://398ae691292f.ngrok.io',
    launchpadUrl: 'http://localhost:3000'
  },
  mutations: {
    token (state, token) {
      state.token = token
      state.authenticated = token !== ''
      localStorage.setItem('auth_token', token)
    },
    name (state, name) {
      state.name = name
      localStorage.setItem('user_name', name)
    },
    profileImage (state, profileUrl) {
      state.profileUrl = profileUrl
      localStorage.setItem('user_pic', profileUrl)
    }
  },
  actions: {
    getName (context) {
      var name = sessionStorage.getItem('user_name')
      var picture = sessionStorage.getItem('user_pic')

      if (name != null && picture != null) {
        context.commit('name', name)
        context.commit('profileImage', picture)
        return
      }

      fetch(context.state.url + '/user/info', {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + context.state.token
        }
      }).then(response => {
        return response.json()
      }).then(data => {
        context.commit('name', data.name)
        if (data.hasOwnProperty('profileUrl')) context.commit('profileImage', data.profileUrl)
      })
    },
    logout (context) {
      context.commit('token', '')
      context.commit('name', '')
      context.commit('profileImage', '')
      localStorage.removeItem('auth_token')
      localStorage.removeItem('user_name')
      localStorage.removeItem('user_pic')
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js